(() => {
  const brand = document.body.dataset.storefrontBrand || 'profusion';
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const cartPath = root + 'cart';
  const csHome = root + 'pages/colourspell';
  const vendorConstraint = brand === 'colourspell'
    ? 'tag:colourspell'
    : '-vendor:"ColourSpell" AND -vendor:"Colour Spell" AND -vendor:"Colour Spell Cosmetics" AND -tag:colourspell AND -tag:ColourSpell';
  function displaySearchTerm(value) {
    let text = value.trim();
    for (let pass = 0; pass < 4; pass++) {
      const decoded = text.replace(/&amp;/gi, '&').replace(/&quot;|&#34;|&#x22;/gi, '"').replace(/&#39;|&#x27;/gi, "'");
      const generated = decoded.match(/^\(?title:"((?:\\.|[^"\\])*)"\s+OR body:/i);
      if (!generated) return text;
      text = generated[1].replace(/\\(["\\])/g, '$1');
    }
    return text;
  }
  function scopedSearchQuery(value) {
    const text = displaySearchTerm(value);
    const escaped = text.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    const fields = ['title', 'body', 'variants.title', 'variants.sku', 'variants.barcode', 'product_type', 'tag'];
    const keyword = text ? '(' + fields.map(name => name + ':"' + escaped + '"').join(' OR ') + ')' : '*';
    return keyword + ' AND (' + vendorConstraint + ')';
  }
  document.addEventListener('formdata', event => {
    const form = event.target;
    if (!form.matches('[data-brand-search]') || form.querySelector('[name="type"]')?.value === 'article') return;
    const field = form.querySelector('[name="q"]');
    if (field) event.formData.set('q', scopedSearchQuery(field.value));
  });
  function matchesWithin(scope, selector) {
    const matches = [...scope.querySelectorAll(selector)];
    if (scope.nodeType === 1 && scope.matches(selector)) matches.unshift(scope);
    return matches;
  }
  function reconcile(scope = document) {
    matchesWithin(scope, '[data-brand-search] [name="q"]').forEach(field => {
      const form = field.closest('[data-brand-search]');
      if (form.querySelector('[name="type"]')?.value === 'article') return;
      const originalQuery = new URLSearchParams(location.search).get('q');
      field.value = displaySearchTerm(originalQuery === null ? field.value : originalQuery);
    });
    matchesWithin(scope, 'a[href]').forEach(link => {
      let url;
      try { url = new URL(link.href, location.href); } catch { return; }
      if (/^(www\.)?colourspellcosmetics\.com$/i.test(url.hostname)) {
        link.href = csHome;
        link.removeAttribute('target');
      }
      if (brand === 'colourspell' && url.origin === location.origin) {
        if (url.pathname === root + 'collections/all') {
          url.pathname = root + 'collections/colourspell';
          url.searchParams.delete('filter.p.vendor');
          link.href = url.pathname + url.search + url.hash;
        }
        const policies = {'shipping-policy':'colourspell-shipping','refund-policy':'colourspell-refund','privacy-policy':'colourspell-privacy','terms-of-service':'colourspell-terms'};
        const policy = url.pathname.startsWith(root + 'policies/') ? url.pathname.split('/').pop() : null;
        if (policies[policy]) link.href = csHome + '?view=' + policies[policy];
        if (url.pathname === cartPath || url.pathname === root + 'search') {
          url.searchParams.set('view', 'colourspell');
          link.href = url.pathname + url.search + url.hash;
        }
      }
    });
    matchesWithin(scope, '[data-product-brand]').forEach(card => {
      if (card.dataset.productBrand.trim() !== brand && !card.closest('[data-cart-form]')) {
        const parent = card.closest('.rv-box-element');
        if (parent) parent.remove(); else card.remove();
      }
    });
  }
  reconcile();
  const observer = new MutationObserver(records => {
    const added = records.flatMap(record => [...record.addedNodes]).filter(node => node.nodeType === 1);
    if (!added.length) return;
    const roots = [...new Set(added)].filter(node => node.isConnected);
    roots.filter(node => !roots.some(parent => parent !== node && parent.contains(node)))
      .forEach(node => reconcile(node));
  });
  observer.observe(document.body, {childList: true, subtree: true});
  document.addEventListener('shopify:section:load', () => reconcile());
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    fetch(root + 'cart.js', {credentials: 'same-origin', headers: {'Accept': 'application/json'}})
      .then(response => response.ok ? response.json() : null)
      .then(cart => {
        if (cart) document.querySelectorAll('[data-shared-cart-count], .cart_count').forEach(node => node.textContent = cart.item_count);
      }).catch(() => {});
  });
})();


